function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as o } from "react/jsx-runtime";
import { useIsInverseVariant as s } from "../../theme-variant-context.js";
import { vars as c } from "../../skins/skin-contract.css-mistica.js";
const i = (_param)=>{
    var { color: l , size: r = 24  } = _param, t = _object_without_properties(_param, [
        "color",
        "size"
    ]);
    const a = s(), e = l !== null && l !== void 0 ? l : a ? c.colors.inverse : c.colors.neutralHigh;
    return /* @__PURE__ */ o("svg", _object_spread_props(_object_spread({
        width: r,
        height: r,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, t), {
        children: /* @__PURE__ */ o("path", {
            fill: e,
            d: "M19.499 6.025c1.201 1.23 1.983 2.857 2.322 4.84.067.37-.037.76-.286 1.068-.266.313-.65.49-1.059.49L12.5 12.4v7.36c0 .685.568 1.246 1.266 1.246a1.26 1.26 0 001.266-1.247c0-.23.19-.417.423-.417a.42.42 0 01.423.417c0 1.146-.947 2.078-2.11 2.078-1.16 0-2.103-.924-2.111-2.064v-7.378l-8.14-.02a1.424 1.424 0 01-.72-.204 1.343 1.343 0 01-.625-1.367c.353-1.983 1.148-3.608 2.364-4.82C6.2 4.3 8.6 3.426 11.656 3.373v-.804c0-.23.191-.418.423-.418a.42.42 0 01.423.418v.798c3.009.092 5.359.986 6.998 2.658zM3.244 11.462a.58.58 0 00.28.081l2.014.006c.664-4.028 2.955-6.188 4.6-7.235-2.099.269-3.78 1.017-5 2.249-1.093 1.092-1.813 2.569-2.135 4.384a.52.52 0 00.24.515zm17.641-.056a.529.529 0 00.107-.4c-.314-1.818-1.017-3.3-2.098-4.404-1.177-1.199-2.782-1.947-4.776-2.252 1.593 1.02 3.65 3.112 4.339 7.233l2.025.005a.52.52 0 00.403-.182zm-8.384-6.963v7.123l5.096.014c-.872-4.922-3.827-6.628-5.096-7.137zm-.843-.017c-1.23.532-4.428 2.361-5.263 7.126l5.263.011V4.426z"
        })
    }));
}, h = i;
export { h as default };
